import Ract from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { View, Text } from '@constants/Themed';
import { Title } from '@constants/Themed';
import { ReportDisplay } from '../ReportsScreen/ReportDashboardScreen';
import { useNavigation, useRoute } from '@react-navigation/native';
import DropDownView from '@components/Global/DropDownView';
import { Image } from 'react-native';
import styles from '@stylesheet';
import toTitleCase from '@hooks/toTitleCase';
import RowComponent from '@components/Global/RowComponent/RowComponent';
import { Progress } from 'tamagui';
import PercentageBar from '@components/Global/PercentageBar';
import * as Animatable from 'react-native-animatable';
import { FontAwesome6 } from '@expo/vector-icons';
import DataSetChart from '@components/dataTables/Charts/DataSetChart';
import DataChart from '@components/dataTables/DataChart';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

const SalesStats = () => {
  const filter = useSelector((state: DefaultRootState) => state.UI.salesDateFilter.label);
  const { id, params } = useRoute().params;
  const navigation = useNavigation();
  
  if (!id || !params) {
    navigation.navigate('Sales')
  }

  return (
    <DefaultScreen style={{ paddingRight: 0 }} scrollDisabled containerStyle={{ paddingRight: 0 }}>
      <View style={{ flex: 1, alignSelf: "stretch", minWidth: "100%", flexDirection: "row" }}>
        <DropDownView removeDrop style={{ flex: 2, minWidth: "40%", width: "40%", maxWidth: "40%" }}>
          {
            params && params.user &&
            <Animatable.View useNativeDriver animation={'slideInLeft'} style={{ paddingHorizontal: 20, flex: 2 }}>
              <View style={[styles.centerEverything, { borderBottomWidth: 2, flex: 1, flexDirection: "row", gap: 20 }]}>
                <Image source={{ uri: params.user.profile_information.avatar.img }} style={{ flex: 2, width: "100%", minWidth: 150, resizeMode: "contain", height: "100%", borderRadius: 15 }} />
                <View style={{ flex: 3, justifyContent: 'center', alignItems: 'center' }}>
                  <Title>{toTitleCase(params.user.profile_information.name)}</Title>
                  <Title>{toTitleCase(params.user.profile_information.surname)}</Title>
                </View>
              </View>
              <View style={{ flex: 4, overflow: "scroll" }}>
                <PercentageBar title='Customer Health' height={20} backgroundColor={'red'} percentage={"20%"} completedColor={'green'} />
                <PercentageBar title='Customer Health' height={20} backgroundColor={'red'} percentage={"20%"} completedColor={'green'} />
                <PercentageBar title='Customer Health' height={20} backgroundColor={'red'} percentage={"20%"} completedColor={'green'} />
                <PercentageBar title='Customer Health' height={20} backgroundColor={'red'} percentage={"20%"} completedColor={'green'} />
                <PercentageBar title='Customer Health' height={20} backgroundColor={'red'} percentage={"20%"} completedColor={'green'} />
              </View>
            </Animatable.View>
          }
        </DropDownView>
        <View style={[styles.centerEverything, { flex: 3, minWidth: "60%" }]}>
          <View style={[styles.item, { alignSelf: "stretch", flexDirection: "row", overflow: "visible", margin: 10, minWidth: 440, minHeight: 400, maxHeight: 420 }]}>
            <View key={"Tools"} style={{ left: 10, alignContent: "center", gap: 10, alignItems: "center", justifyContent: "center", padding: 15, zIndex: 1, margin: 10, maxHeight: "90%", position: "relative", flex: 0.000001, alignSelf: "stretch", minHeight: "100%", borderRadius: 10, backgroundColor: "#f3f3f3", minWidth: 65 }}>
              <FontAwesome6 name="star" size={24} color="black" />
              {/* <Checkbox onPress={() => handleSelect(item.key)} status={selected.includes(item.key) ? "checked" : "unchecked"} /> */}
              <FontAwesome6 name="filter" size={24} color="white" style={{ borderRadius: 20, backgroundColor: "rgb(90,192,234)", padding: 7 }} />
              <FontAwesome6 name="folder-open" size={24} color="white" style={{ borderRadius: 20, backgroundColor: "rgb(90,192,234)", padding: 7 }} />
            </View>
            <View style={{ flex: 10, overflow: "visible", flexGrow: 10, justifyContent: "flex-start", alignContent: "flex-start", alignItems: "center" }}>
              <Title>{toTitleCase(filter)} Sales</Title>
              <DataChart />
            </View>
          </View>
        </View>
      </View >
    </DefaultScreen >
  )
}
export default SalesStats;